import cn from 'classnames';
import React from 'react';
import { useSiteStyles } from '../../../../hooks/useSiteStyles';
import { DeviceType } from '../../../../types/DeviceType';
import { Theme } from '../../../../types/Theme';
import { DH } from '../../../../utils/DataHook';
import { Dropdown, DropdownOption } from '../../../Dropdown';
import * as s from './styles.scss';
import { DropdownFieldErrorMessage, DropdownFieldLabel } from './elements';
import { MFieldName } from '../../../../types/MandatoryFields';
import { useAdaptedComponents } from '../../../../hooks/useAdaptedComponents';

interface DropdownFieldViewProps {
  deviceType: DeviceType;
  theme: Theme;
  isValidationError: boolean;
  isLoadingOptions: boolean;
  shouldApplySiteStyles: boolean;
  showLabel: boolean;
  labelText: string;
  required: boolean;
  value: string;
  name: MFieldName;
  errorMessage: string;
  items: DropdownOption[];

  onSelect(option: DropdownOption);
}

export const DropdownFieldView: React.FunctionComponent<DropdownFieldViewProps> =
  (props) => {
    const { textColor } = useSiteStyles();
    const Components = useAdaptedComponents();

    if (Components) {
      return (
        <Components.Dropdown
          name={props.name}
          label={props.showLabel ? props.labelText : null}
          initialSelectedId={props.value}
          options={props.items.map((item) => ({
            id: item.value,
            value: item.label,
          }))}
          theme={props.theme}
          required={props.required}
          disabled={props.isLoadingOptions}
          onChange={(option) =>
            props.onSelect({
              id: option.id,
              value: option.value,
              label: option.value,
            })
          }
          errorMessage={props.isValidationError && props.errorMessage}
          deviceType={props.deviceType}
          placeholder={!props.showLabel ? props.labelText : ''}
        />
      );
    }

    return (
      <div
        className={cn({
          [s.root]: true,
          [s.modalTheme]: props.theme === Theme.modal,
          [s.mobile]: props.deviceType === 'mobile',
          [s.invalid]: props.isValidationError,
        })}
        data-hook={DH.PaymentDetails.DropdownField.Dropdown}
      >
        {props.showLabel && (
          <DropdownFieldLabel
            labelText={props.labelText}
            name={props.name}
            required={props.required}
            style={
              props.shouldApplySiteStyles && textColor
                ? { color: textColor }
                : null
            }
          />
        )}
        <div className={s.dropdownWrapper}>
          <Dropdown
            invalid={props.isValidationError}
            required={props.required}
            disabled={props.isLoadingOptions}
            selectedOptionId={props.value}
            placeholder={!props.showLabel ? props.labelText : ''}
            options={props.items}
            onSelect={props.onSelect}
            label={props.labelText}
          />
        </div>

        {props.isValidationError && props.errorMessage && (
          <DropdownFieldErrorMessage
            errorMessage={props.errorMessage}
            name={props.name}
          />
        )}
      </div>
    );
  };
DropdownFieldView.displayName = 'DropdownFieldView';
